<template>
  <div>
    <h2>错题记录</h2>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="student_id" label="学生ID" width="100"></el-table-column>
      <el-table-column prop="content" label="题目内容"></el-table-column>
      <el-table-column prop="user_answer" label="用户答案"></el-table-column>
      <el-table-column prop="standard_answer" label="标准答案"></el-table-column>
      <el-table-column prop="is_mastered" label="是否掌握">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_mastered ? 'success' : 'danger'">{{ scope.row.is_mastered ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="记录时间" width="180"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data() { return { tableData: [], loading: false } },
  created() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.getWrongQuestions({skip:0, limit:100});
        this.tableData = res.items || [];
      } catch (e) { console.error(e) }
      finally { this.loading = false; }
    }
  }
}
</script>